import React from 'react';
import { getActiveIcon, getStatusName } from 'library/helpers';
import { convertUtcToLocalDate, durationString } from 'library/time';
import NotificationInput from './input';

const config = {
  init: {
    is_before: true
  },
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Type',
        dataIndex: 'type',
        width: '200px',
        sorter: true,
        defaultSortOrder: 'ascend',
        render: (text, record) => record.type.name
      },
      {
        title: 'Duration',
        dataIndex: 'delta',
        width: '200px',
        sorter: true,
        render: (text, record) => (durationString(record.delta))
      },
      {
        title: 'Run Before',
        dataIndex: 'is_before',
        width: '140px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [{
          text: 'Yes',
          value: true
        }, {
          text: 'No',
          value: false
        }],
        render: (text, record) => getActiveIcon(record.is_before)
      },
      {
        isRunOnly: true,
        title: 'Run Status',
        dataIndex: 'status',
        width: '140px',
        sorter: true,
        render: (text, record) => getStatusName(record.status)
      },
      {
        isRunOnly: true,
        title: 'Run Success Date',
        dataIndex: 'success_date',
        sorter: true,
        render: (text, record) => (record.success_date ? convertUtcToLocalDate(record.success_date)
          .format('YYYY/MM/DD HH:mm:ss') : 'None')
      }
    ],
    // Deleting
    confirmMessage: () => (
      <div>
        <p>
          Are you sure you wish to delete the Notification?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'notification_type',
      order: 'ascend'
    },
    filters: {},
    customFilters: {},
    // General
    title: 'Notifications',
    commands: {
      showDelete: false,
      showAdd: false
    },
    isRecordDeletable: record => !(record.status && record.status !== 'P'),
    isRecordEditable: record => !(record.status && record.status !== 'P')
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Record',
    title: 'Default Notification',
    component: props => (
      <NotificationInput
        title="Default Notification"
        {...props}
      />
    )
  }
};

export default config;
